module.exports = __webpack_public_path__ + "static/media/video_border.4153992b.jpg";